import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Button, Text, H4, H3, H2, Dropdown, Panel } from '@bigcommerce/big-design';
import { ArrowDropDownIcon, FileDownloadIcon } from '@bigcommerce/big-design-icons';

import ToolPage from '../partials/ToolPage';
import NoLabelTemplatesBox from '../partials/NoLabelTemplatesBox';
import PrintLine from "./PrintLine";
import ModifyCountDialog from './ModifyCountDialog';
import LoadingSpinner from '../partials/LoadingSpinner';

import { indexBarcodeTemplates } from '../../redux/actions/barcodeTemplates';
import { requestPrint } from '../../redux/actions/prints';
import { productCustomFields } from '../../redux/actions/products';
import { locationsIndex } from '../../redux/actions/locations';

const PrintBarcodes = ({ payload, getTemplates, selectedProductList, barcodeTemplates, postPrint, downloadUrl, prints, missingBarcodes, settings, getCustomFields, customFields, locations, loadLocations }) => {
  const [submitted, setSubmitted] = useState(false);
  const [activeTemplate, setActiveTemplate] = useState({});
  const [modifyItem, setModifyItem] = useState(null);
  const [modifyType, setModifyType] = useState(null);
  const [modifyCount, setModifyCount] = useState(null);
  const [modifyItemId, setModifyItemId] = useState(null);
  const [showPrintCountDialog, setShowPrintCountDialog] = useState(false);
  const [labelCount, setLabelCount] = useState(0);

  const [activeLocation, setActiveLocation] = useState(null);

  const [printCounts, setPrintCounts] = useState({
      products: {},
      variations: {}
    }
  )

  const [sortOrder, setSortOrder] = useState('SKU');

  const switchActiveTemplate = (event) => {
    let template = barcodeTemplates.templates.find(template => template.uuid === event.hash);
    setActiveTemplate(template);
  }

  const templates = () => {
    let templateItems = [];

    barcodeTemplates.templates.map(template => 
      templateItems.push(
        {
          content: template.template_name,
          onItemClick: (event) => switchActiveTemplate(event),
          hash: template.uuid
        }
      )
    )

    return templateItems;
  }

  const setPrintCount = (type, itemId, modifyItem, count) => {
    let tempCounts = printCounts;

    tempCounts[type][itemId] = {
      count: count,
      item: modifyItem
    };

    setPrintCounts(tempCounts);
    calculateTotal();
  }

  const calculateTotal = () => {
    let tempTotal = 0;

    Object.keys(selectedProductList.products).map(itemId =>
      tempTotal = tempTotal + (parseInt(printCounts.products[itemId]?.count) || 0)
    )

    Object.keys(selectedProductList.variations).map(itemId => 
      tempTotal = tempTotal + (parseInt(printCounts.variations[itemId]?.count) || 0)
    )

    setLabelCount(tempTotal);
  }

  const setAllToZero = () => {
    let tempCounts = {
      products: {},
      variations: {}
    };

    Object.keys(selectedProductList.products).map(itemId =>
      tempCounts.products[itemId] = {
        count: 0,
        item: selectedProductList.products[itemId]
      }
    )

    Object.keys(selectedProductList.variations).map(itemId =>
      tempCounts.variations[itemId] = {
        count: 0,
        item: selectedProductList.variations[itemId]
      }
    )

    setPrintCounts(tempCounts);
  }

  const setAllToOne = () => {
    let tempCounts = {
      products: {},
      variations: {}
    };

    Object.keys(selectedProductList.products).map(itemId =>
      tempCounts.products[itemId] = {
        count: 1,
        item: selectedProductList.products[itemId]
      }
    )

    Object.keys(selectedProductList.variations).map(itemId =>
      tempCounts.variations[itemId] = {
        count: 1,
        item: selectedProductList.variations[itemId]
      }
    )

    setPrintCounts(tempCounts);
  }

  const setAllToInventory = () => {
    let tempCounts = {
      products: {},
      variations: {}
    };

    Object.keys(selectedProductList.products).map(itemId =>
      tempCounts.products[itemId] = {
        count: selectedProductList.products[itemId].quantity,
        item: selectedProductList.products[itemId]
      }
    )

    Object.keys(selectedProductList.variations).map(itemId =>
      tempCounts.variations[itemId] = {
        count: selectedProductList.variations[itemId].quantity,
        item: selectedProductList.variations[itemId]
      }
    )

    setPrintCounts(tempCounts);
  }

  const sortItems = () => {
    let items = [];

    items.push(
      {
        content: 'SKU',
        onItemClick: () => setSortOrder('SKU'),
        hash: 'SKU'
      }
    );

    items.push(
      {
        content: 'Bin Picking Number (Default location)',
        onItemClick: () => setSortOrder('Bin Picking Number (Default location)'),
        hash: 'Bin Picking Number (Default location)'
      }
    );

    items.push(
      {
        content: 'Name',
        onItemClick: () => setSortOrder('Name'),
        hash: 'Name'
      }
    );



    return items;
  }

  const switchLocation = (event, setter) => {
    let location = locations.locations.find(location => location.id === event.hash);
    setter(location);
  }

  const locationItems = () => {
    let items = [];

    locations.locations.map(location => 
      items.push(
        {
          content: location.label,
          onItemClick: (event) => switchLocation(event, setActiveLocation),
          hash: location.id
        }
      )
    )

    return items;
  }

  const download = () => {
    let postCustomFields = {};


    customFields.forEach(customField => {
      postCustomFields[customField.product_id] = [];

      activeTemplate.custom_field_options?.forEach(templateCustomFieldOption => {
        let matchingField = customField.custom_fields.find( productField => productField.name === templateCustomFieldOption.field_name)

        if(matchingField) {
          postCustomFields[customField.product_id].push(matchingField)
        }
      })

    })

    postPrint(payload, activeTemplate.uuid, printCounts, sortOrder, postCustomFields, activeLocation?.id);
    setSubmitted(true);
  }

  useEffect(() => {
    getTemplates(payload);
    setAllToZero();

    if(settings.settings.enable_custom_fields) {
      loadLocations(payload);
    }
  }, []);

  useEffect(() => {
    calculateTotal();
  }, [printCounts]);

  useEffect(() => {
    if(downloadUrl && submitted) { 
      let win = window.open(downloadUrl, '_blank');
      win.focus();
      setSubmitted(false);
    }
  }, [downloadUrl]);

  useEffect(() => {
    if (barcodeTemplates.status === 'success' && barcodeTemplates.templates.length > 0 && !activeTemplate.uuid) {
      setActiveTemplate(barcodeTemplates.templates[0]);

      // Load custom fields if custom fields are active
      if(settings.settings.enable_custom_fields) {
        let allProductIds = Object.keys(selectedProductList.products).map(itemId => selectedProductList.products[itemId].relatedProductId).concat(Object.keys(selectedProductList.variations).map(itemId => selectedProductList.variations[itemId].relatedProductId));
        allProductIds = [...new Set(allProductIds)];

        allProductIds.forEach((productId) => {
          getCustomFields(payload, productId);
        })

      }
    }
  }, [barcodeTemplates]);

  const description = () => {
    return(
      <> 
        <Text>Select a template to print the selected barcodes with by choosing it from the Templates dropdown.</Text>
        <Text>You can select the number of labels to print for all products from the buttons from the top card. "Set All to 0" sets the print count of all items to 0, "Set All to 1" sets the counts to 1, and "Set All to Quantity in Stock" will set the number of labels to print to match the number of items of that type in stock.</Text>
        <Text>You can also click on any item to modify the print count of any individual item.</Text>
        <Text>Once you have a template selected and a print count set for your items, click the "Confirm and Download Print File" button to download a print pdf.</Text>
        <Text>Note: you can still print labels for items that are missing barcodes. The labels will have an empty space where the barcode would have been. If your label template doesn't use a barcode row, you can ignore these warnings.</Text>
      </>
    )
  }

  return(
    <>
      <ToolPage title="Print Barcodes" description={description()} helpLink="bigcommerce/print-barcode-labels/">
        <Panel>
          <H2>Print Template</H2>
          { barcodeTemplates.status === 'success' && barcodeTemplates.templates.length > 0 && 
            <Dropdown
              items={templates()}
              maxHeight={250}
              placement="bottom-start"
              toggle={<Button iconRight={<ArrowDropDownIcon />}>{activeTemplate?.template_name || "Select Template"}</Button>}
            />
          }
          { barcodeTemplates.status === 'success' && barcodeTemplates.templates.length === 0 && 
            <NoLabelTemplatesBox/>
          }

          { barcodeTemplates.status !== 'success' &&
            <LoadingSpinner size="xxSmall" statusText="Loading Templates" />
          }
          { activeTemplate?.uuid && (labelCount > 0) && (prints.status !== "requesting") && 
            <div className="top-15">
              <Button iconRight={<FileDownloadIcon />} onClick={() => download()}>
                Confirm and Download Print File
              </Button>
              <Text color="warning40">
                Please ensure your browser allows popups for this page when downloading your print file.
              </Text>
            </div> }
          { (!activeTemplate.uuid || (labelCount === 0)) && (prints.status !== "requesting") && <div className="top-15"><Button iconRight={ <FileDownloadIcon /> } disabled>Confirm and Download Print File</Button></div> }
          { prints.status === "requesting" && 
            <div className="top-15">
              <LoadingSpinner size="xxSmall" statusText="Generating Print File" />
              <Text color="warning40">
                Please ensure your browser allows popups for this page when downloading your print file.
              </Text>
            </div>
          }
          <hr/>

          <H3>Print Settings</H3>

          <div className="background-darken padding-20 flex-container">
            <div className="flex-1">
              <H4>Sort Order</H4>
              <Dropdown
                items={sortItems()}
                maxHeight={250}
                placement="bottom-start"
                toggle={<Button iconRight={<ArrowDropDownIcon />}>{sortOrder}</Button>}
              />
            </div>

            <div className="flex-1">
              { settings.settings.enable_bpn_location &&
                <>
                  <H4>Location</H4>
                  { locations.status !== 'success' &&
                    <LoadingSpinner size="xxSmall" statusText="Loading Locations" />
                  }

                  { locations.status === 'success' &&
                    <Dropdown
                      items={locationItems()}
                      maxHeight={250}
                      placement="bottom-start"
                      toggle={<Button iconRight={<ArrowDropDownIcon />}>{activeLocation?.label || "Select Location"}</Button>}
                    />
                  }
                </>
              }
            </div>

          </div>
          <br/>
          <br/>

          <span><Button variant="secondary" onClick={() => setAllToZero()}>Set All to 0</Button></span>
          <span className="left-15"><Button variant="secondary" onClick={() => setAllToOne()}>Set All to 1</Button></span>
          <span className="left-15"><Button variant="secondary" onClick={() => setAllToInventory()}>Set All to Quantity in Stock</Button></span>
        </Panel>
        <Panel>
          { Object.keys(selectedProductList.products).map(itemId =>
              <PrintLine
                id={itemId}
                itemId={itemId}
                item={selectedProductList.products[itemId]}
                type='products'
                printCount={printCounts.products[itemId]?.count}
                setModifyItem={setModifyItem}
                setModifyType={setModifyType}
                setModifyCount={setModifyCount}
                setModifyItemId={setModifyItemId}
                setShowPrintCountDialog={setShowPrintCountDialog}
                missingBarcode={ (missingBarcodes.indexOf(selectedProductList.products[itemId].sku) !== -1) || (missingBarcodes.indexOf(selectedProductList.products[itemId].upc) !== -1) }
                customFieldOptions={activeTemplate.custom_field_options}
              />
            )
          }
          { Object.keys(selectedProductList.variations).map(itemId =>
              <PrintLine
                id={itemId}
                itemId={itemId}
                item={selectedProductList.variations[itemId]}
                type='variations'
                printCount={printCounts.variations[itemId]?.count}
                setModifyItem={setModifyItem}
                setModifyType={setModifyType}
                setModifyCount={setModifyCount}
                setModifyItemId={setModifyItemId}
                setShowPrintCountDialog={setShowPrintCountDialog}
                missingBarcode={ (missingBarcodes.indexOf(selectedProductList.variations[itemId].sku) !== -1) || (missingBarcodes.indexOf(selectedProductList.variations[itemId].upc) !== -1) }
                customFieldOptions={activeTemplate.custom_field_options}
              />
            )
          }
        </Panel>

      </ToolPage>

      { showPrintCountDialog &&
        <ModifyCountDialog
          modifyItemId={modifyItemId}
          modifyItem={modifyItem}
          modifyType={modifyType}
          modifyCount={modifyCount}
          setPrintCount={setPrintCount}
          setShowPrintCountDialog={setShowPrintCountDialog}
          showPrintCountDialog={showPrintCountDialog}
        />
      }
    </>
  )
}

const mapStateToProps = state => ({
  selectedProductList: state.products.selectedProductList,
  missingBarcodes: state.products.missingBarcodes,
  barcodeTemplates: state.barcodeTemplates,
  prints: state.prints,
  downloadUrl: state.prints.downloadUrl,
  settings: state.settings,
  customFields: state.products.customFields,
  locations: state.locations,
});

const mapDispatchToProps = (dispatch) => ({
  getTemplates: (payload) => dispatch(indexBarcodeTemplates(payload)),
  postPrint: (payload, template, printCounts, sortOrder, printCustomFields, locationId) => dispatch(requestPrint(payload, template, printCounts, sortOrder, printCustomFields, locationId)),
  getCustomFields: (payload, productIds) => dispatch(productCustomFields(payload, productIds)),
  loadLocations: (payload) => dispatch(locationsIndex(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PrintBarcodes);
